import React, { useState, useEffect } from 'react'
import { Link } from 'react-scroll'
import { isClient } from 'config/web/configHelper'
import style from './ScrollIndicator.scss'

const ScrollIndicator = ({ id = 'content' }) => {
    const [scroll, setScroll] = useState(false)

    const handleScroll = e => {
        const scrollPos = window.scrollY

        if (scrollPos > 0) {
            setScroll(true)
        } else {
            setScroll(false)
        }
    }

    useEffect(() => {
        if (isClient) {
            window.addEventListener('scroll', handleScroll)

            return () => window.removeEventListener('scroll', handleScroll)
        }
    }, [scroll])

    return (
        <Link
          className={style(style.scroll, { [style.hidden]: scroll })}
          to={id}
          duration={1200}
          smooth="easeOutQuad"
        >
            <div className={style.arrow} />
            <div className={style.arrow} />
        </Link>
    )
}

export default ScrollIndicator
